import { Component, OnInit, Output, EventEmitter  } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { menulist } from '../class/status';
import { page } from '../class/status';
import { environment } from '../../../environments/environment';
import { Rtable } from '../class/rtabledata';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-checkinfo',
  templateUrl: './checkinfo.component.html',
  styleUrls: ['./checkinfo.component.css']
})

export class CheckinfoComponent implements OnInit {

  @Output() notify = new EventEmitter<any>();


  constructor(
    public httpClient: HttpClient,
    private  route: ActivatedRoute,
  ){}

  ngOnInit(): void {
    this.preurl = environment.serverurl;
    if(this.route.snapshot.paramMap.get('id')){
      this.search_str = this.route.snapshot.paramMap.get('id');
      this.search_model = '1';//通過
      this.ch_menu('1');//kyc
    }else{
      this.ch_menu('0');
    }
  }

  loading:boolean=true;
  preurl :string = '';
  link:string = environment.link;
  status_option:menulist = [{ "id": '-1', "name": "不通過" }, { "id": '0', "name": "待審核" }, { "id": '1', "name": "通過" }];
  status_model:string;
  search_model:string = '0';
  search_str:string = '';
  edit_data:any;
  data:any=[];
  posts_attributes:any=[];
  tmp_img_b64:any='';
  posts_input:any=[];
  why:string='';
  pageobj:page = {page:0,count:10,total_count:0};
  pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
  menu_list:menulist = [{id:'0',name:'銀行帳戶審核'},{id:'1',name:'kyc認證'}]
  now:string = '0';

    init_list(){
      const body = {page: this.pageobj.page,count:this.pageobj.count,status:this.search_model,now:this.now,search:this.search_str};
      this.httpClient.post<any>("/get_validate_profile.php",body).subscribe(res => {
        this.loading = false;
        if(res.status){
          this.data = res.data;
          this.pageobj.total_count = res.total_count
        }else{
          this.pageobj.total_count = 0
          this.data = [];
        }
        this.posts_input = {
          attribute:this.posts_attributes,
          content:this.data,
        }
        console.log(res);
        this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      }, error => {
        console.log(error);
      });
    }

    onStatusChange(newStatus: string) {
      if(newStatus === '1'){
        // 當選擇通過時，自動修改下方的輸入值
        this.edit_data.is_hidden = 1;
        this.edit_data.sort_score = 1;
      }else {
        this.edit_data.is_hidden = 0;
        this.edit_data.sort_score = -3;
      }
    }

    handleImageUpload(file: File,type:Number): void {

        this.edit_data.pic = file;
    }

    cancel_pic(){
        this.edit_data.pic = '';
    }

    db_ck(){
      if(confirm('是否刪除原本上傳的圖片')){
        this.edit_data.certified_documents = '';
      }
    }

    identityName(identity:any):string{
      const map:{[key:string]:string} = {
        '0':'簽約員工',
        '1':'一般用戶',
        '2':'內部員工',
        '3':'經紀成員',
        '4':'業配人員',
        '5':'陪聊',
        '6':'內部經紀',
        '7':'外部經紀',
        '99':'官方帳號',
      };
      return map[String(identity)] ?? `未知(${identity})`;
    }

    submit(){

    let pic_status = 0; //是否上傳其他圖片
    if(this.tmp_img_b64.length>0){
        this.edit_data.certified_documents = this.tmp_img_b64;
        pic_status = 1;
    }

    this.loading = true;

    const body = {msg:this.why,status:this.status_model,id:this.edit_data.id,now:this.now,edit_data:this.edit_data,pic_status:pic_status};

    this.httpClient.post<any>("/update_validate_profile.php",body).subscribe(res => {
        this.loading = false;

        if(res.status){
            this.init_list();
        }
    }, error => {
        console.log(error);
    });

  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }


  upload(event:any){
    let fileList: FileList = event.target.files;

    if(fileList.length > 0) {
      let file: File = fileList[0];
      var reader = new FileReader();
      reader.readAsDataURL(file);//读出 base64
      reader.onloadend = ((e)=>{
        this.tmp_img_b64 = e.target.result;
      });
    }
  }


  ch_menu(now){
    let tmp_data = {};
    this.now = now;
    this.pageobj.page=0;
    Rtable.structure.type = 'txt';
    if(now=='0'){
      tmp_data = {
        id_name:{name:'會員名'},
        bank_accountname:{name:'戶名'},
        nick:{name:'暱稱',type:'opt'},
        status:{name:'審核狀態',type:'opt'},
        msg:{name:'審核點平'},
        gender:{name:'性別'},
        update_uid:{name:'審批者'},
        create_dt:{name:'建立時間'},
        update_dt:{name:'修改時間'},
        opt:{name:'操作',type:'opt'},
      }
    }else{
      tmp_data = {
        nick:{name:'暱稱',type:'opt'},
        status:{name:'審核狀態',type:'opt'},
        msg:{name:'審核點評',type:'opt'},
        update_uid:{name:'審批者'},
        gender:{name:'性別'},
        create_dt:{name:'建立時間'},
        update_dt:{name:'修改時間'},
        opt:{name:'操作',type:'opt'},
      }
    }
    this.posts_attributes = Rtable.init(tmp_data);
    this.init_list();
  }
}
